// extracted by mini-css-extract-plugin
module.exports = {"hasPromotion":"_3B-pbTb4gjIgDVNkdbLrk","carryMore":"_1MSHlmKrojDER-B3Suf1dC","container":"_2QklPxMlV0Ex4FttO23vkh"};